import React, { useEffect, useRef } from 'react';

import { ta, taf } from '../../i18n/adminT';
const MAX_IMAGE_BYTES = 200 * 1024; // 200 KB, per non far gonfiare troppo l'email

// Componente "non controllato" di proposito: il contenuto HTML viene scritto
// nel DOM solo al montaggio (leggendo "value"), poi vive lì finché l'utente
// digita, notificando il genitore via onChange. Se venisse ri-scritto ad
// ogni cambio di stato React perderebbe la posizione del cursore ad ogni
// carattere digitato. Per forzare un contenuto diverso (es. cambio lingua),
// il genitore deve montare una nuova istanza passando una prop "key" diversa.
export default function RichTextEditor({ value, onChange, placeholder }) {
  const editorRef = useRef(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (editorRef.current) editorRef.current.innerHTML = value || '';
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exec = (command, arg) => {
    editorRef.current.focus();
    document.execCommand(command, false, arg);
    onChange(editorRef.current.innerHTML);
  };

  const handleInput = () => onChange(editorRef.current.innerHTML);

  const handleImageButtonClick = () => fileInputRef.current?.click();

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    e.target.value = '';
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      alert(ta('Scegli un file immagine (PNG, JPEG, ecc.).'));
      return;
    }
    if (file.size > MAX_IMAGE_BYTES) {
      alert(taf('Immagine troppo grande (max {kb} KB). Riducila e riprova: molti client email bloccano o tagliano le immagini pesanti.', { kb: Math.round(MAX_IMAGE_BYTES / 1024) }));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => exec('insertImage', reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <div className="rich-editor">
      <div className="rich-editor__toolbar">
        <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => exec('bold')} title={ta('Grassetto')}><b>{ta('B')}</b></button>
        <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => exec('italic')} title={ta('Corsivo')}><i>{ta('I')}</i></button>
        <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => exec('underline')} title={ta('Sottolineato')}><u>{ta('U')}</u></button>
        <span className="rich-editor__sep" />
        <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={handleImageButtonClick} title={ta('Inserisci immagine')}>{ta('🖼 Immagine')}</button>
        <input ref={fileInputRef} type="file" accept="image/*" onChange={handleImageChange} style={{ display: 'none' }} />
      </div>
      <div
        ref={editorRef}
        className="rich-editor__content"
        contentEditable
        onInput={handleInput}
        data-placeholder={placeholder}
        suppressContentEditableWarning
      />
    </div>
  );
}
